var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3286 8.94406H1M3.78076 11.3276L1 8.94406L3.78076 6.56055",
    stroke: "#3A416F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 4.97252C6.57212 3.24445 6.64875 2.3086 7.25923 1.69811C7.95737 1 9.08096 1 11.3281 1H12.1226C14.3698 1 15.4935 1 16.1915 1.69811C16.8897 2.39623 16.8897 3.51983 16.8897 5.76702V12.1231C16.8897 14.3702 16.8897 15.4938 16.1915 16.1919C15.581 16.8024 14.6452 16.8791 12.917 16.8887M6.5625 12.9176C6.57212 14.6456 6.64875 15.5815 7.25923 16.1919C7.76876 16.7015 8.50486 16.8392 9.73897 16.8763",
    stroke: "#3A416F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.0b5f49897a88c616f313713437d24041.svg";
export { ForwardRef as ReactComponent };